export interface StatusOption {
  value: boolean | number | string;
  text: string;
}

export const statusOptions: StatusOption[] = [
  {
    value: false,
    text: '停用',
  },
  {
    value: true,
    text: '啟用',
  },
];
